import controller from './product-not-found.controller';
import templateBase from './templates/product-not-found-base.view.html';
import templateAD from './templates/product-not-found-adaptative.html';


let ProductNotFoundComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
  
    if(__env.adaptative) {
      return templateAD;
    } else {
      return templateBase;
    }
}

export default ProductNotFoundComponent;


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/product-not-found/product-not-found.component.js
 **/